import { useMutation } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { guacHttpClient } from "@/lib/http";
import { CreateOrUpdateJobRequest, HttpResponse, Job } from "@/types";

export function useUpdateJob() {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();

  const mutation = useMutation({
    mutationFn: async ({ request }: { request: CreateOrUpdateJobRequest }) => {
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}`;
      const res = await guacHttpClient.patch<
        Job,
        HttpResponse<Job>,
        CreateOrUpdateJobRequest
      >(path, request);

      return res.data;
    },
  });

  return mutation;
}
